import React, { FC } from 'react';
import ConditionalTooltip from '@app/components/ConditionalTooltip';
import { SaveButton, SaveButtonTooltipAnchor } from '../NewVerificationTab.styles';

interface Props {
  hasChanges: boolean;
  isSaving?: boolean;
  /** When set, Save is disabled and this text explains why (shown as a tooltip). */
  blockedReason?: string;
  onSave: () => void;
  testId?: string;
}

// The tooltip anchors on the wrapper span rather than the button: a disabled native button emits
// no mouse events, so the disabled SaveButton drops pointer events and the span receives the hover.
export const VerificationSaveButton: FC<Props> = ({ hasChanges, isSaving, blockedReason, onSave, testId }) => (
  <ConditionalTooltip showTooltip={!!blockedReason} title={blockedReason} placement='top'>
    <SaveButtonTooltipAnchor>
      <SaveButton data-testid={testId} disabled={!hasChanges || isSaving || !!blockedReason} onClick={onSave}>
        {isSaving ? 'Saving…' : 'Save Changes'}
      </SaveButton>
    </SaveButtonTooltipAnchor>
  </ConditionalTooltip>
);
